define('apps/admin/views/modals/send-domain-verification-code-modal',[
        'app',
        'njs!apps/admin/templates/includes/modals/_send_domain_verification_code_modal(params:tmpl=admin/main/includes/modals/_send_domain_verification_code_modal.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal__button--confirm": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
            },

            "template": template,

            "sendDomainVerificationCodeXHR": null,

            "initialize": function(opts){
                this.model.on('change', this.render, this);

                // check for required domain
                var domain = this.model.get('domain');
                if (!domain) {
                    this.model.set({
                        'modalHeader': 'Missing Domain Address',
                        'modalText': 'Please enter a domain first.',
                        'completed': true,
                        'showOKButton': true
                    });
                    return;
                }

                this.callApi();
            },

            "callApi": function(){
                var url = this.model.get('apiUrl');

                var params = {
                    'token': this.model.get('token'),
                    'local_part': this.model.get('localPart'),
                    'domain': this.model.get('domain'),
                };

                var requestSettings = {
                    'url': url,
                    'method': 'POST',
                    'data': params,
                    'xhrFields': {
                        'withCredentials': true
                    },
                    'beforeSend': _.bind(function () {
                        // cancel previous request before starting new request
                        if (this.sendDomainVerificationCodeXHR !== null && this.sendDomainVerificationCodeXHR.readyState !== 4) {
                            this.sendDomainVerificationCodeXHR.abort();
                        }
                    }, this),
                };

                this.sendDomainVerificationCodeXHR = $.ajax(requestSettings)
                    .done(_.bind(function (data, textStatus, jqXHR) {
                        var responseMessage = data.message;
                        $('.admin-onboarding__input--verification-code').addClass('admin-onboarding__input--visible');
                        $('.admin-form__button--add').removeClass('admin-form__button--hidden');
                        $('.domain__field-group').removeClass('comet-form--error');

                        this.model.set({
                            'modalHeader': 'Email Sent',
                            'modalText': responseMessage,
                            'completed': true,
                            'showOKButton': true,
                            'okButtonLabel': 'Got it',
                            'showSuccessIcon': true
                        });

                    }, this))
                    .fail(_.bind(function (jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        window.console.log("Request Failed: " + err);

                        var response = JSON.parse(jqxhr.responseText);
                        var responseMessage = response.meta.message;
                        this.model.set({
                            'modalHeader': 'Error',
                            'modalText': responseMessage,
                            'completed': true,
                            'showOKButton': true
                        });

                        $('.domain__field-group').addClass('comet-form--error');
                    }, this));
            },


            "closeModal": function(event) {
                this.destroy();
            },

        });
});

